import { useState, useRef } from "react";
import sizeReferenceDisplay from "@utils/constants/sizeReferenceDisplay";
import { useSizeReferenceDisplay } from "./use-current-user";

const sizeReferenceOrder = { [sizeReferenceDisplay.FR]: 0, [sizeReferenceDisplay.IT]: 1 };
const ANIM_DURATION = 220;

export function useSizeReferenceAnimation() {
  const initialSizeReference = useSizeReferenceDisplay();

  const [pendingSizeReference, setPendingSizeReference] = useState(initialSizeReference); // the size reference that is being switched to, but not visible yet
  const [visibleSizeReference, setVisibleSizeReference] = useState(initialSizeReference); // the size reference that is currently visible
  const [animPhase, setAnimPhase] = useState(null);

  const animTimeoutRef = useRef(null);

  function handleSizeReferenceChange(newRef) {
    if (animTimeoutRef.current) clearTimeout(animTimeoutRef.current);

    const dir =
      sizeReferenceOrder[newRef] > sizeReferenceOrder[pendingSizeReference] ? "up" : "down";

    setPendingSizeReference(newRef);
    setAnimPhase(`exit-${dir}`);

    animTimeoutRef.current = setTimeout(() => {
      setVisibleSizeReference(newRef);
      setAnimPhase(`enter-${dir}`);

      animTimeoutRef.current = setTimeout(() => {
        setAnimPhase(null);
        animTimeoutRef.current = null;
      }, ANIM_DURATION);
    }, ANIM_DURATION);
  }

  function resetSizeReference(ref) {
    if (animTimeoutRef.current) clearTimeout(animTimeoutRef.current);
    setAnimPhase(null);
    setPendingSizeReference(ref);
    setVisibleSizeReference(ref);
  }

  return {
    selectedSizeReference: pendingSizeReference,
    visibleSizeReference,
    animPhase,
    handleSizeReferenceChange,
    resetSizeReference,
  };
}
